export default {
    cancelText: '取消'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/search-bar/locale/zh_CN.js
// module id = 423
// module chunks = 0